import { CircularProgress, CircularProgressProps } from '@mui/material';

export const Loader = (props: CircularProgressProps) => (
    <CircularProgress
        {...props}
        sx={{
            color: 'secondary.main',
            position: 'absolute',
            top: 'calc(50% - 20px)',
            left: 'calc(50% - 20px)',
            ...props.sx,
        }}
    />
);
